import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { HEADER_HEIGHT, PROFILE_SUBNAV_HEIGHT } from '@/config/constants';
import { isLoanFlowPath } from '@/config/loanNavPaths';
import { useAuth } from './useAuth';

export const useAppLayout = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const showLoanSubnav = isAuthenticated && isLoanFlowPath(location.pathname);
  const showSecondarySubnav = showLoanSubnav;

  const headerHeight = useMemo(() => {
    let h = HEADER_HEIGHT;
    if (showSecondarySubnav) h += PROFILE_SUBNAV_HEIGHT;
    return h;
  }, [showSecondarySubnav]);

  return {
    headerHeight,
    showLoanSubnav,
    showSecondarySubnav,
  };
};
